import { connect } from "react-redux";
import { get } from "lodash";

import { CompanyBranchesAndSubsidiariesComponent } from "./CompanyBranchesAndSubsidiaries";
import {
  getOrgKYCDetails,
  getRoDocuments,
  getOrganizationInfoRO
} from "../../../../../../store/selectors/appConfig";
import { sendProspectToAPIPromisify } from "../../../../../../store/actions/sendProspectToAPI";
import {
  updateProspect,
  updateRoProspect,
  receiveDatalistSearchPromisify
} from "../../../../../../store/actions/appConfig";

const mapStateToProps = state => ({
  orgKYCDetails: getOrgKYCDetails(state),
  roDocuments: getRoDocuments(state),
  sisterCompanyDetails: get(getOrganizationInfoRO(state), "sisterCompanyDetails", [])
});

const mapDispatchToProps = {
  updateProspect,
  updateRoProspect,
  sendProspectToAPI: sendProspectToAPIPromisify,
  getDatalistSearch: receiveDatalistSearchPromisify
};

export const CompanyBranchesAndSubsidiaries = connect(
  mapStateToProps,
  mapDispatchToProps
)(CompanyBranchesAndSubsidiariesComponent);
